// ======================================================================
// File Name       : ContentQuestionList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import PropTypes from 'prop-types';
import React from 'react';
import { Button, Table, Col, Form } from 'react-bootstrap';
import {
  AUTH_REDIRECT_URL, DRILL_CLIENT_URL, PREVIEW_QUESTION_WINDOW_NAME, QUESTION_CONVERT_ERROR_URL, X_SSAPI_VERSION,
} from '../../constants';
import { CONVERT_STATUS, DATA_AFFIILIATION_TYPE_TEXT } from '../../constants/ContentConstant';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import DrillImage from '../../images/icon/drill.png';
import { getItemBoxName, parseDateForDetail } from '../../utils/index';
import ReduxFormPaging from '../ReduxFormPaging';
import CustomButton from '../button/CustomButton';
import CustomLink from '../button/CustomLink';
import * as ICON from '../../constants/IconConstants';
import { CONTENT_QUESTION_DETAIL } from '../../constants/PathConstants';

class ContentQuestionList extends React.Component {
  constructor() {
    super();
    this.openPreviewQuestion = this.openPreviewQuestion.bind(this);
  }

  openPreviewQuestion(previewQuestionLink) {
    const newWindow = window.open(previewQuestionLink, PREVIEW_QUESTION_WINDOW_NAME, 'height=750,width=1000,menubar=no,toolbar=no,scrollbars=yes,resizable=yes');
    newWindow.focus();
  }

  render() {
    const { questions, handleSortState, goToDetail, invalid, institutionId, recordNum, startPosition, getStartEndData, hoverIndex } = this.props;
    const getConvertStatusTypeText = (convertStatus) => {
      try {
        const convertedValue = parseInt(convertStatus, 10);
        return SELECT_BOX_DATA.CONVERT_STATUS.filter(item => item.value === convertedValue)[0].name;
      } catch (error) {
        return convertStatus;
      }
    };
    const thead = [
      { title: '問題識別ID', sortBy: 0},
      { title: '問題タイトル', sortBy: 1 , width:'30%'},
      { title: '外部', sortBy: 3, width:'5%'},
      { title: '登録日時', sortBy: 8},
      { title: '登録者', sortBy: null}, // Step 9.0.0
      { title: '変換ステータス', sortBy: 2},
      { title: '操作', sortBy: null, width:200}, // Step9.0.1
    ];
    const { bySecernId, allSecernIds } = questions;
    return (
      <div>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="questionSortType"
              invalid={invalid}
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>
            {allSecernIds.map((questionSecernId, index) => {
              const {
                questionTitle,
                convertStatus,
                dataAffiliationType,
                createdAt,
                createdUserName, // Step 9.0.0
              } = bySecernId[
                questionSecernId
              ];
              // #7155 START
              const previewQuestionLink = `${DRILL_CLIENT_URL}/QuestionPreviewHtml?institution_id=${institutionId}&question_secern_id=${questionSecernId}&auth_redirect_uri=${AUTH_REDIRECT_URL}&X-SSapi-version=${X_SSAPI_VERSION}&convert_redirect_uri=${QUESTION_CONVERT_ERROR_URL}`;
              // #7155 END
              // If question is completed conversion, プレビュー button is displayed.
              const isCompletedConversion = (convertStatus === CONVERT_STATUS.CONVERSION_SUCCESS);
              const link = CONTENT_QUESTION_DETAIL.replace(':id', questionSecernId);
              return (
                <tr key={index} onMouseEnter={() => this.props.handleMouseEnter(index)} onMouseLeave={() => this.props.handleMouseLeave()}>
                  <td >
                    <div> {questionSecernId} </div>
                  </td>
                  <td>
                    {questionTitle}
                  </td>
                  <td>
                    {getItemBoxName(DATA_AFFIILIATION_TYPE_TEXT, dataAffiliationType)}
                  </td>
                  <td>
                    {parseDateForDetail(createdAt)}
                  </td>
                  {/* Step 9.0.0 START */}
                  <td>
                    {createdUserName}
                  </td>
                  {/* Step 9.0.0 END */}
                  <td>
                    {getConvertStatusTypeText(convertStatus)}
                  </td>
                  <td className="text-center">
                    <div className="inline-flex">
                      {isCompletedConversion &&
                        <CustomLink
                          className="btn-edit float-end margin-right-10"
                          onClick={this.openPreviewQuestion.bind(this, previewQuestionLink)}
                          text="プレビュー"
                        />
                      }
                      <CustomLink
                        className="margin-right-7 link-detail-edit"
                        to={link}
                        text="詳細"
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <Form.Group>
          <Col sm={12} className="text-center">
            <ReduxFormPaging
              type="paging"
              name="startPosition"
              recordNum={recordNum}
              getStartEndData={getStartEndData}
            />
          </Col>
        </Form.Group>
      </div>
    );
  }
}
ContentQuestionList.propTypes = {
  questions: PropTypes.shape({
    bySecernId: PropTypes.shape().isRequired,
    allSecernIds: PropTypes.array.isRequired,
  }).isRequired,
};

export default ContentQuestionList;
